import { useNavigate } from "react-router-dom";
import { Agent, AgentMetrics } from "../../api/agents";
import "./AgentsCollapsed.css";

interface AgentsCollapsedProps {
    agents: Agent[];
    metrics: Map<string, AgentMetrics>;
}

export function AgentsCollapsed({ agents, metrics }: AgentsCollapsedProps) {
    const navigate = useNavigate();

    const handleExpand = (agentName: string) => {
        navigate(`/agents?name=${agentName}`);
    };

    return (
        <table className="agents-table">
            <thead>
                <tr>
                    <th>Agent Name</th>
                    <th>Messages Answered</th>
                    <th>Handoffs</th>
                    <th>Errors</th>
                    <th>Model</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {agents.map((agent) => {
                    const agentMetrics = metrics.get(agent.agentName);
                    return (
                        <tr key={agent.agentName} className="agent-row">
                            <td className="agent-name-cell">
                                <span className="agent-status"></span>
                                <span>{agent.agentName}</span>
                            </td>
                            <td>{agentMetrics?.messagesAnswered ?? 0}</td>
                            <td>{agentMetrics?.handoffs ?? 0}</td>
                            <td>{agentMetrics?.errors ?? 0}</td>
                            <td>{agent.model}</td>
                            <td className="expand-cell">
                                <button className="expand-btn" onClick={() => handleExpand(agent.agentName)}>
                                    Expand
                                    <span className="expand-icon">»</span>
                                </button>
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
}
